import React, { Component } from "react";
import { Row, Col, Table, Card } from "react-bootstrap";
import CommonRecordsNotFound from "../components/CommonRecordsNotFound";
import { getChartColorSet } from "../../library/charts";

/**
 * @typedef {Object} DataTableDashboardCustomProps
 * @property {string} [maxHeight]
 * @property {React.CSSProperties} [tableStyle]
 * @property {React.CSSProperties} [rowStyle]
 */

/** @extends {Component<DataTableDashboardCustomProps>} */

class DataTableDashboardCustom extends Component {
    render() {
        const {
            data,
            title,
            icon,
            bg = "primary",
            columnName = [],
            cardWrap = true,
            colorOpacityWithValue = false,
            checkPreviousRow = false,
            maxHeight = null,
            tableStyle = {},
            rowStyle = {}
        } = this.props;

        const globalValues = [];

        columnName.forEach((col) => {
            if (col === "ปี" || col === "รวม") return;

            data?.rows?.forEach((row) => {
                globalValues.push(Number(row[col]) || 0);
            });
        });

        globalValues.sort((a, b) => a - b);

        const totalColumnValues = data.rows?.map((row) => Number(row["รวม"]) || 0)
            .sort((a, b) => a - b);

        const getRankColor = (value, values, colorSet = "1") => {
            if (!values || values.length === 0) return undefined;

            const index = values.indexOf(value);
            const ratio = (index) / values.length;

            const minOpacity = 0.01;
            const maxOpacity = 0.8;

            const opacity =
                colorOpacityWithValue ? (minOpacity + (maxOpacity - minOpacity) * ratio) : 0;

            return {
                bg: getChartColorSet(colorSet, opacity).valueOpacity,
                isDark: opacity >= 0.28
            };;
        };

        const tableContent = (
            <Row style={cardWrap ? {} : { position: 'relative', maxHeight: maxHeight ?? '350px', overflowY: 'auto' }}>
                <Col md={12}>
                    <Table responsive borderless className="table-advance table-visible no-row-hover" style={tableStyle}>
                        <thead className="table-primary">
                            <tr>
                                {columnName.map((col, i) => (
                                    <th key={i} className="text-center">
                                        {col}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {data?.rows?.length > 0 ? (
                                data?.rows?.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {columnName.map((col, i) => {
                                            const value = Number(row[col]) || 0;

                                            let colorInfo = { bg: undefined, isDark: false };

                                            if (col === "ปี") {
                                                colorInfo = { bg: undefined, isDark: false };
                                            } else if (col === "รวม") {
                                                colorInfo = getRankColor(value, totalColumnValues, "1");
                                            } else {
                                                colorInfo = getRankColor(value, globalValues, "1");
                                            }

                                            const beforeCol = data?.rows?.[rowIndex - 1]?.[col];

                                            return (
                                                <td
                                                    key={i}
                                                    className={`heatmap-cell ${col === "อุตสาหกรรม" || col === "ชื่อสถานศึกษา" ? "text-start" : "text-center"}`}
                                                    title={row[col]}
                                                    style={{
                                                        backgroundColor: colorInfo.bg,
                                                        color: colorInfo.isDark ? "#fff" : undefined,
                                                        borderRadius: 0,
                                                        ...rowStyle,
                                                    }}
                                                >
                                                    {checkPreviousRow ?
                                                        row[col] == null
                                                            ? "-"
                                                            : row[col] === beforeCol
                                                                ? ""
                                                                : row[col]
                                                    : row[col] ?? "-" }
                                                </td>
                                            );
                                        })}

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columnName.length} className="text-center">
                                        <CommonRecordsNotFound />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        );

        return cardWrap ? (
            <Card className="card-border mb-5">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">
                        {icon && <i className={`${icon} me-2`} />}
                        {title}
                    </h6>
                </Card.Header>
                <Card.Body style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {tableContent}
                </Card.Body>
            </Card>
        ) : (
            tableContent
        );
    }
}

export default DataTableDashboardCustom;
